import { Button, Label, Spinner, Textarea } from 'flowbite-react';
import { get } from 'lodash';
import React, { useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { cancelInterviewRound } from 'src/apis/application';
import { useToast } from 'src/context/ToastProvider';
interface Props {
	userName: string;
	userId?: string;
	positionId?: string;
	isLoading?: boolean;
	onFinish?: () => void;
	onSubmit?: (data: { positionId: string; remarks: string }) => void;
}

const CancelInterview = ({ userName, userId, positionId, onFinish, onSubmit, isLoading }: Props) => {
	const queryClient = useQueryClient();
	const toast = useToast();

	const [remarks, setRemarks] = useState<string>();

	const cancelInterviewFn = useMutation(['cancelInterviewRound'], cancelInterviewRound, {
		onSuccess() {
			queryClient.refetchQueries({ queryKey: ['getRecommendationsForPosition'], exact: false });
			toast({
				title: 'Interview cancelled successfully',
				type: 'success',
			});
			onFinish && onFinish();
		},
		onError(error: Error) {
			const errorMessage = get(error, ['response', 'data', 'message'], error.message);
			toast({
				title: `Error occured while cancelling interview ${errorMessage}`,
				type: 'error',
			});
		},
	});

	const handleSubmit = () => {
		if (onSubmit) {
			onSubmit({
				positionId: positionId || '',
				remarks: remarks || '',
			});
		} else {
			if (positionId && remarks)
				cancelInterviewFn.mutate({
					positionId,
					remarks,
					userId: userId || '',
				});
		}
	};

	return (
		<div className="flex flex-col gap-[20px]">
			<p className="font-inter text-[18px] font-[500] leading-[28px]">
				{'Cancel Interview for '} <span className="font-[700]">{userName}</span>
			</p>
			<div className="block">
				<div className="mb-[8px] flex justify-between items-end">
					<div>
						<Label>{'Your message '}</Label>
						<span className="text-[red]">*</span>
					</div>

					<span className="italic text-xs text-[#6B7280] ">{remarks?.length + ' / ' + 640}</span>
				</div>
				<Textarea
					name="message"
					placeholder="Write message here ..."
					value={remarks}
					maxLength={640}
					onChange={e => {
						setRemarks(e.target.value);
					}}
					className="border bg-white dark:text-white dark:border-[#4B5563] min-h-[100px] dark:bg-[#374151] focus:border-transparent focus:!ring-[1px] focus:!ring-[#7777E7]"
				/>
			</div>
			<Button
				disabled={cancelInterviewFn.isLoading || isLoading}
				onClick={() => {
					handleSubmit();
				}}
				className="mt-[16px] mx-auto"
				color="purplePlaced"
			>
				{cancelInterviewFn.isLoading || isLoading ? <Spinner /> : 'Confirm'}
			</Button>
		</div>
	);
};

export default CancelInterview;
